import { render, staticRenderFns } from "./showFamilyInformation.vue?vue&type=template&id=3932be7c&"
import script from "./showFamilyInformation.vue?vue&type=script&lang=js&"
export * from "./showFamilyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports